module.exports = __webpack_public_path__ + "img/FLAT.b059805d.jpg";